import Vue from 'vue'
import Router from 'vue-router'
import routes from '../routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/front/',
  linkActiveClass: 'on',
  scrollBehavior (to, from, savedPosition) { // https://router.vuejs.org/kr/guide/advanced/scroll-behavior.html
    if (savedPosition) {
      return savedPosition // 뒤로가기 했을때에는 기억하고 있던 위치로 이동
    } else {
      return { x: 0, y: 0 } // 새로 클릭시에는 무조건 최상단으로 스크롤 이동
    }
  },
  routes
})

export default router